import { useCallback } from 'react';
import { Box, Center, Radio, SimpleGrid, Stack } from '@mantine/core';

import { Button, Select } from 'components';
import { CardRequestStep } from 'types';

const CardInformationStep = ({
  form,
  onSubmit,
  options,
  t,
}: CardRequestStep) => {

  const onSubmitWrapper = useCallback(() => {
    onSubmit();
  }, [form.values, options]);

  return (
    <Center>
      <Box w={'80%'}>
        <SimpleGrid cols={{ base: 1, md: 2 }}>
          <Stack>
            <Select
              label={t('input.cardOwner.label')}
              data={options['cardOwner'].map(el => (
                { value: el, label: t(`input.cardOwner.options.${el}`) }
              ))}
              key={form.key('cardOwner')}
              {...form.getInputProps('cardOwner')}
              clearable={true}
            />
            <Radio.Group
              name={'cardLostCase'}
              label={t('input.cardLostCase.label')}
              key={form.key('cardLostCase')}
              {...form.getInputProps('cardLostCase')}
            >
              <Box mt={'xs'}>
                <Radio
                  label={t('input.cardLostCase.options.BASIC_SECURITY.title')}
                  value={'BASIC_SECURITY'}
                  mb={'sm'}
                  color={'#75AD53'}
                />
                <Radio
                  label={t('input.cardLostCase.options.FAMILY_SECURITY.title')}
                  value={'FAMILY_SECURITY'}
                  mb={'sm'}
                  color={'#75AD53'}
                />
                <Radio
                  label={t('input.cardLostCase.options.NO_SECURITY.title')}
                  value={'NO_SECURITY'}
                  color={'#75AD53'}
                />
              </Box>
            </Radio.Group>
          </Stack>
        </SimpleGrid>
        <Button mt={'lg'} onClick={onSubmitWrapper}>
          {t('action.submitRequest')}
        </Button>
      </Box>
    </Center>
  )
}

export default CardInformationStep;